import { render, staticRenderFns } from "./footerBar.vue?vue&type=template&id=02b4c372&scoped=true&"
import script from "./footerBar.vue?vue&type=script&lang=js&"
export * from "./footerBar.vue?vue&type=script&lang=js&"
import style0 from "./footerBar.vue?vue&type=style&index=0&id=02b4c372&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b4c372",
  null
  
)

export default component.exports